import { Card } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../Redux Store/actions";
import {
  getAllAgreementCount,
  getAllAllotmentsCount,
  getAllEvents,
  getSiteVisitsCount,
  getTokensCount,
  getTotalLeadsCount,
} from "../../Services/LeadService";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { handleErrors } from "../../Services/LoginService";
import { offlineToast } from "../../Services/Toast";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import cssClasses from "./Dashboard.module.css";
import EventDefaultImg from "../../Assets/Images/eventDefaultImage.svg";
import Calendar from "../../Assets/Images/calendar.svg";
import Dot from "../Icons/Dot";
//Images
import ViewMore from "../../Assets/Images/viewMoreIcon.svg";
import targetIcon from "../../Assets/Images/targetIcon.svg";
import circle from "../../Assets/Images/circle.svg";
import TotalLeadsIcon from "../../Assets/Images/TotalLeads.svg";
import TotalAllomentsIcon from "../../Assets/Images/TotalAllotmentsIcon.svg";
import AgreementsIcon from "../../Assets/Images/TotalAgreements.svg";
import SiteVisitIcon from "../../Assets/Images/TotalSiteVisitIcon.svg";
import TotalTokensIcon from "../../Assets/Images/TotalTokensIcon.svg";
import PlaceIcon from '@mui/icons-material/Place';
import EmptyListIcon from '../../Assets/Images/EmptyDataIcons/Illustrations.svg';
import * as _ from 'lodash';
import Chart from "react-apexcharts";
// ? capacitor network for online/offline status
import { Network } from '@capacitor/network';
import { useNavigate } from "react-router-dom";
const Dashboard = () => {
  const navigate=useNavigate();
  const dispatch = useDispatch();
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const [countArr, setCountArr] = useState([
    {
      title: "Total Leads",
      value: 0,
      percentage: "0%",
      color: "#027A48",
      backgroundColor: "#ECFDF3",
    },
    {
      title: "Active Leads",
      value: 0,
      percentage: "0%",
      color: "#027A48",
      backgroundColor: "#ECFDF3",
    },
    {
      title: "Site Visits",
      value: 0,
      percentage: "0%",
      color: "#027A48",
      backgroundColor: "#ECFDF3",
    },
    {
      title: "Tokens",
      value: 0,
      percentage: "0%",
      color: "#027A48",
      backgroundColor: "#ECFDF3",
    },
    {
      title: "Allotments",
      value: 0,
      percentage: "0%",
      color: "#027A48",
      backgroundColor: "#ECFDF3",
    },
    {
      title: "Agreements",
      value: 0,
      percentage: "0%",
      color: "#027A48",
      backgroundColor: "#ECFDF3",
    },
  ]);
  const [events, setEvents] = useState([]);
  const [leadsCount, setLeadsCount] = useState(0);
  const [siteVisitsCount, setSiteVistsCount] = useState(0);
  const [allotmentsCount, setAllomentsCount] = useState(0);
  const [tokenCount, setTokenCount] = useState(0);
  const [totalAgreement, setTotalAgreement] = useState(0);
  const [chart, setChart] = useState({
    optionsRadial: {
      plotOptions: {
        radialBar: {
          startAngle: 0,
          endAngle: 360,
          hollow: {
            margin: 0,
            size: "80%",
            background: "#fff",
            image: undefined,
            imageOffsetX: 0,
            imageOffsetY: 0,
            position: "front",
            dropShadow: {
              enabled: true,
              top: 3,
              left: 0,
              blur: 4,
              opacity: 0.24,
            },
          },
          track: {
            background: "#fff",
            strokeWidth: "67%",
            margin: 0, // margin is in pixels
            dropShadow: {
              enabled: true,
              top: -3,
              left: 0,
              blur: 4,
              opacity: 0.35,
            },
          },

          dataLabels: {
            showOn: "always",
            name: {
              offsetY: -20,
              show: true,
              color: "#888",
              fontSize: "14px",
            },
            value: {
              formatter: function (val) {
                return val;
              },
              color: "#111",
              fontSize: "20px",
              show: true,
            },
          },
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "horizontal",
          shadeIntensity: 0.5,
          gradientToColors: ["#1570EF"],
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100],
        },
      },
      stroke: {
        lineCap: "round",
      },
      labels: ["Brokerage"],
    },
    seriesRadial: [70],
  });
  var today = new Date();
  var curHr = today.getHours();
  const [eventsPresent, setEventsPresent] = useState(null);
  var data = [
    [22, 'Working late'],
    [18, 'Good evening'],
    [12, 'Good afternoon'],
    [9, 'Good morning'],
    [5, 'Whoa, early bird']
  ];
  const [greetingMsg, setGreetingMsg] = useState('');
  useEffect(() => {
    dispatch(actions.activeMenu("home"));
    const hr = new Date().getHours();
    for (var i = 0; i < data.length; i++) {
      if (hr >= data[i][0]) {
        setGreetingMsg(data[i][1]);
        break;
      }
    }
    Network.getStatus().then((res) => {
      if (res.connected) {
        getLeadCounts();
        getEvents();
      } else {
        offlineToast();
      }
    });
  }, []);
  function getLeadCounts() {
    Network.getStatus().then((resp) => {
      if (resp.connected) {
        presentLoader();
        getTotalLeadsCount(loggedInUser.cpId, loggedInUser.fosId)
          .then((resp) => {
            setLeadsCount(resp.count);
            // ? find index of 'total leads' in array and set count
            const totalLeadsIndex = countArr.findIndex(
              (count) => count.title === "Total Leads"
            );
            setCountArr((pre) => {
              pre[totalLeadsIndex].value = resp.count;
              pre[totalLeadsIndex].percentage = resp.count > 0 ? "100%" : "0%";
              return [...pre];
            });
            const activeLeadsArr = resp.data.filter(
              (lead) =>
                lead.leadResponse === "HOT" || lead.leadResponse === "WARM"
            );
            // ? find index of 'active leads' in array and set count
            const activeLeadsIndex = countArr.findIndex(
              (count) => count.title === "Active Leads"
            );
            setCountArr((pre) => {
              pre[activeLeadsIndex].value = activeLeadsArr.length;
              pre[activeLeadsIndex].percentage =
                activeLeadsArr.length > 0 && resp.count > 0
                  ? ((activeLeadsArr.length / resp.count) * 100).toFixed(2) + "%"
                  : "0%";
              return [...pre];
            });
            dismissLoader();
          })
          .catch((err) => {
            console.log("err: ", err);
            dismissLoader();
            handleErrors(err, "get total leads count");
          });
        getSiteVisitsCount(loggedInUser.cpId, loggedInUser.fosId)
          .then((resp) => {
            setSiteVistsCount(resp.count);
            // ? find index of 'site visit' in array and set count
            // ! total site visits of all cp/fos leads
            const siteVisitsIndex = countArr.findIndex(
              (count) => count.title === "Site Visits"
            );
            const totalLeadsIndex = countArr.findIndex(
              (count) => count.title === "Total Leads"
            );
            setCountArr((pre) => {
              pre[siteVisitsIndex].value = resp.count;
              pre[siteVisitsIndex].percentage =
                resp.count > 0 && pre[totalLeadsIndex].value > 0
                  ? ((resp.count / pre[totalLeadsIndex].value) * 100).toFixed(2) +
                  "%"
                  : "0%";
              return [...pre];
            });
          })
          .catch((err) => {
            console.log("err: ", err);
            dismissLoader();
            handleErrors(err, "get total site visit count");
          });
        getTokensCount(loggedInUser?.cpId, loggedInUser?.fosId)
          .then((resp) => {
            console.log("resp.data",resp.data)
            let tokenCount=0;
            resp.data.forEach((lead)=>{
              tokenCount+=lead.EventTokenLeadRelations.length
            });
            console.log({tokenCount});
            setTokenCount(tokenCount);
            // ? find index of 'tokens' in array and set count
            // ! total tokens bought by leads
            const tokensIndex = countArr.findIndex(
              (count) => count.title === "Tokens"
            );
            const totalLeadsIndex = countArr.findIndex(
              (count) => count.title === "Total Leads"
            );
            console.log("totalLeadsIndex: ", totalLeadsIndex);
            setCountArr((pre) => {
              pre[tokensIndex].value = tokenCount;
              pre[tokensIndex].percentage =
                resp.count > 0 && pre[totalLeadsIndex].value > 0
                  ? ((resp.count / pre[totalLeadsIndex].value) * 100).toFixed(2) +
                  "%"
                  : "0%";
              console.log(
                "pre[tokensIndex].percentage: ",
                pre[tokensIndex].percentage
              );
              return [...pre];
            });
          })
          .catch((err) => {
            console.log("err: ", err);
            dismissLoader();
            handleErrors(err, "get total tokens count");
          });
        getAllAllotmentsCount(loggedInUser.cpId, loggedInUser.fosId)
          .then((resp) => {
            console.log('allAllotments',resp);
           let allotmentCount= resp.data.filter(({Leads})=>Leads!==null);
            // ? find index of 'allotments' in array and set count
            // ! total allotments by leads
            const allotmentsIndex = countArr.findIndex(
              (count) => count.title === "Allotments"
            );
            const totalLeadsIndex = countArr.findIndex(
              (count) => count.title === "Total Leads"
            );
            setCountArr((pre) => {
              pre[allotmentsIndex].value = allotmentCount.length;
              pre[allotmentsIndex].percentage =
              allotmentCount.length > 0
                  ? ((allotmentCount.length / pre[totalLeadsIndex].value) * 100).toFixed(2) +
                  "%"
                  : "0%";
              return [...pre];
            });
          })
          .catch((err) => {
            console.log("err: ", err);
            dismissLoader();
            handleErrors(err, "get total tokens count");
          });
          getAllAgreementCount(loggedInUser.cpId, loggedInUser.fosId).then((resp)=>{
            console.log({resp})
            let allotmentCount= resp.data.filter(({Leads})=>Leads!==null);
            console.log({allotmentCount})
            // ? find index of 'allotments' in array and set count
            // ! total allotments by leads
            const allotmentsIndex = countArr.findIndex(
              (count) => count.title === "Agreements"
            );
            const totalLeadsIndex = countArr.findIndex(
              (count) => count.title === "Total Leads"
            );
            setCountArr((pre) => {
              pre[allotmentsIndex].value = 0;
              pre[allotmentsIndex].percentage =
              allotmentCount.length > 0
                  ? ((allotmentCount.length / pre[totalLeadsIndex].value) * 100).toFixed(2) +
                  "%"
                  : "0%";
              return [...pre];
            });
          })
      } else {
        offlineToast();
      }
    });
  }
  function getEvents() {
    Network.getStatus().then((resp) => {
      if (resp.connected) {
        presentLoader();
        getAllEvents(loggedInUser.cpId)
          .then((resp) => {
            resp.data = resp.data.map((el, index) => ({
              ...el,
              index: index,
              id: el.eventId,
              eventtitle:el.eventtitle
            }));
            const allEvents = _.chain(resp.data).groupBy('eventid').map((value, key) => ({ eventId: key, launch: value })).value();
            console.log('allEvents: ', allEvents);
            setEvents(allEvents);
            console.log("events: ", resp);
            setEventsPresent(resp.data.length > 0 ? true : false);
            dismissLoader();
          })
          .catch((err) => {
            dismissLoader();
            handleErrors(err, "get events");
          });
      } else {
        offlineToast();
      }
    });
  }
  return (
    <div className={cssClasses.pageWrapper}>
      {window.innerWidth > 820 ? (
        <>
          <div className={cssClasses.pageHeader}>
            <div className={cssClasses.pageTitle}>Overview</div>
          </div>
          <div className={cssClasses.leadCountWrap}>
            {countArr.map((count) => (
              <Card className={cssClasses.leadCountCard}
              
              >
                <div className={cssClasses.cardTitle}>{count.title}</div>
                <div className={cssClasses.cardValueWrap}>
                  <div className={cssClasses.cardValue}>{count.value}</div>
                  {/* <div className={cssClasses.cardValuePerc}>
                    <LeadStatusChip
                      label={count.percentage}
                      style={{
                        color: count.color,
                        backgroundColor: count.backgroundColor,
                      }}
                    ></LeadStatusChip>
                  </div> */}
                </div>
              </Card>
            ))}
          </div>
        </>
      ) : (
        <div className={cssClasses.wrapperTargetPage}>
          <div className={cssClasses.wrapperHeader}>
            <div className={cssClasses.wrapperTitleUserName}>
              <div className={cssClasses.headerTitle}>
                {/* Good {curHr < 12 ? 'Morning' : (curHr < 18 ? 'Afternoon' : 'Evening')} */}
                {greetingMsg}
              </div>
              <div
                className={cssClasses.loggedInUserName}
                title={loggedInUser.name}
              >
                {loggedInUser.name}
              </div>
            </div>
            {/* <div
          className={cssClasses.headerTitle}
          style={{ cursor: "pointer" }}
          onClick={() => {
            navigate("/Home/Profile");
          }}
        >
          Edit Profile
        </div> */}
          </div>
          <div className={cssClasses.wrapperCard}>
            <div className={cssClasses.wrapperCardBlock}>
              <img
                src={targetIcon}
                alt={"TargetIcon"}
                style={{ marginRight: "1rem" }}
              />
              <div className={cssClasses.titleYourPerformace}>
                Your Performance
              </div>
            </div>
            <div className={cssClasses.wrapperChartAndData}>
              <div className={cssClasses.wrapperData}>
                <div className={cssClasses.wrapperDataContent}>
                  <img src={TotalLeadsIcon} alt={"circleIcon"} />
                  <div className={cssClasses.headerTitle}>
                    Total Leads
                  </div>
                  <div className={cssClasses.cardValue}>{leadsCount}</div>
                </div>
                <div className={cssClasses.wrapperDataContent}>
                  <img src={SiteVisitIcon} alt={"circleIcon"} />
                  <div className={cssClasses.headerTitle}>
                    Total site visits
                  </div>
                  <div className={cssClasses.cardValue}>
                    {siteVisitsCount}
                  </div>
                </div>
                <div className={cssClasses.wrapperDataContent}>
                  <img src={TotalAllomentsIcon} alt={"circleIcon"} />
                  <div className={cssClasses.headerTitle}>
                    Total Allotments
                  </div>
                  <div className={cssClasses.cardValue}>
                    {allotmentsCount}
                  </div>
                </div>
                <div className={cssClasses.wrapperDataContent}>
                  <img src={TotalTokensIcon} alt={"circleIcon"} />
                  <div className={cssClasses.headerTitle}>
                    Total Tokens
                  </div>
                  <div className={cssClasses.cardValue}>{tokenCount}</div>
                </div>
                <div className={cssClasses.wrapperDataContent}>
                  <img src={AgreementsIcon} alt={"circleIcon"} />
                  <div className={cssClasses.headerTitle}>
                    Total Agreement
                  </div>
                  <div className={cssClasses.cardValue}>{totalAgreement}</div>
                </div>
              </div>
              {/* <div className={cssClasses.chartWrapper}>
                <Chart
                  options={chart.optionsRadial}
                  series={chart.seriesRadial}
                  type="radialBar"
                  width={window.innerWidth > 820 ? 280 : window.innerWidth > 360 ? 210 : 200}
                />
              </div> */}
            </div>
          </div>
        </div>
      )}
      {eventsPresent && (
        <div className={cssClasses.eventsWrapper}>
          {
            events.map((event) => (
              <Card className={cssClasses.eventWrap}>
                <div className={cssClasses.eventInfo}
                 >
                  <div className={cssClasses.eventImg}>
                    {event && event.launch[0].bannerimgurl ? (
                      <img
                        src={
                          process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
                          event.launch[0].bannerimgurl
                        }
                        alt="Event"
                      />
                    ) : (
                      <img src={EventDefaultImg} alt="Event" />
                    )}
                  </div>
                  <div className={cssClasses.eventData}>
                    <div className={cssClasses.eventStatus}>
                      {event.launch[0].eventstartdatetime>Date.now()&&event.launch[0].eventenddatetime>Date.now()&&(
                           <LeadStatusChip
                           label={'Upcoming event'}
                           icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                           style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                         ></LeadStatusChip>
                      )}
                       {event.launch[0].eventstartdatetime<Date.now()&&event.launch[0].eventenddatetime>Date.now()&&(
                           <LeadStatusChip
                           label={'Live event'}
                           icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                           style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                         ></LeadStatusChip>
                      )}
                         {event.launch[0].eventstartdatetime<Date.now()&&event.launch[0].eventenddatetime<Date.now()&&(
                           <LeadStatusChip
                           label={'Closed event'}
                           icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                           style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
                         ></LeadStatusChip>
                      )}
                    </div>
                    <div className={cssClasses.eventName}>{event.launch[0].eventtitle}</div>
                    <div className={cssClasses.eventLaunches}>
                      {event.launch.map((launch, index) => (
                        <div className={cssClasses.launchWrap}>
                          <div className={cssClasses.launchIcon}>
                            <PlaceIcon />
                          </div>
                          <div className={cssClasses.launchLoc}>
                            {launch.launchtitle}, {launch.addressline2}
                          </div>

                        </div>
                      ))}
                    </div>
                    <div className={cssClasses.eventDate}>
                      <div className={cssClasses.launchIcon}>
                        <img src={Calendar} alt="Event Schedule" />
                      </div>
                      <div className={cssClasses.launchLoc}>
                        From <span className={cssClasses.bold}>
                          {new Date(event.launch[0].eventstartdatetime).toDateString()},{" "}
                          {new Date(event.launch[0].eventstartdatetime).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </span> to <span className={cssClasses.bold}>
                          {new Date(event.launch[0].eventenddatetime).toDateString()},{" "}
                          {new Date(event.launch[0].eventenddatetime).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </span>
                      </div>
                    </div>
                    <div className={cssClasses.viewMore}
                    ><img src={ViewMore}
                    style={{cursor:'pointer'}}
                    alt={"More"}
                    onClick={() => {
                      navigate("/Home/Dashboard/ViewLaunches");
                      localStorage.setItem('launch', JSON.stringify(event))
                    }}
                    /></div>
                    {/* <div className={cssClasses.eventDate}>
                  <img src={Calendar} alt="Event Schedule" />
                  End Date: {new Date(event.endDateTime).toDateString()},{" "}
                  {new Date(event.endDateTime).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </div> */}
                  </div>
                </div>
              </Card>
            ))
          }
        </div>
      )}
      {eventsPresent === false && (
        <div className={cssClasses.noDataWrapper}>
          <div className={cssClasses.noDataMsg}>
            <div className={cssClasses.emptyIcon}>
              <img src={EmptyListIcon} alt="No Projects" />
            </div>
            <div className={cssClasses.emptyTitle}>
              No events to show!
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
